import { axiosInstance } from './api';

/** План заказа (Алексей 27.10 #2972; «В план заказа» в Данных — 05.11 #4464) — BE plugins/ops_tasks/api/order_plan.py.
 *  Справочно: чего не хватило за период — звук, отзывы, голос, недопродажи по чекам, выкладка, визиты. */
export type OrderPlanNoteKind = 'speech' | 'review' | 'voice' | 'undersale' | 'layout' | 'visit';

export interface OrderPlanNote {
  kind: OrderPlanNoteKind;
  at: string;
  text: string;
  quote: string;
  conversation_id?: number;
  review_id?: number;
  /** undersale — позиция чеков (для ?item= во вкладке «Недопродажи»). */
  item?: string;
  rack_id?: number;
  visit_id?: number;
  /** Заметка про день целиком (выкладка) — время не показываем. */
  all_day?: boolean;
}

export interface OrderPlanItem {
  name: string;
  count: number;
  last_at: string;
  kinds: OrderPlanNoteKind[];
  notes: OrderPlanNote[];
}

export interface OrderPlanDto {
  date_from: string;
  date_to: string;
  sources: { mic: boolean; reviews_maps: boolean; review_form: boolean; receipts?: boolean; visits?: boolean };
  items: OrderPlanItem[];
}

export const getOrderPlan = (zoneId: string, dateFrom?: string, dateTo?: string) =>
  axiosInstance.get<OrderPlanDto>(`/ops_tasks/order-plan/${zoneId}/`, { params: { date_from: dateFrom, date_to: dateTo } });
